import React from "react";
import { RCCGrid, RCCLoader } from "react-common-components";

const Loader: React.FC = () => <RCCGrid
	container
	item
	alignItems="center"
	justifyContent="center"
	style={{padding: "10px"}}
>
	<RCCLoader color="purple" />
</RCCGrid>;

export default Loader;
